import { Center, Loader, Stack, Text } from '@mantine/core';
import { type ReactNode } from 'react';

/** Fallback visible para chunks diferidos; evita una pantalla vacía. */
export function RouteLoadingFallback(): ReactNode {
  return (
    <Center
      mih={240}
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-agent-id="admin.route.loading"
    >
      <Stack align="center" gap="sm">
        <Loader size="sm" aria-hidden="true" />
        <Text c="dimmed">Cargando sección…</Text>
      </Stack>
    </Center>
  );
}
